<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelCheck()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button *ngIf="documentTemp.customer.id && documentTemp.site.id" (click)="scanItem()">
                <ion-icon slot="icon-only" name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Hospital Stock Reconciliation</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <customer [document]="documentTemp" (customerChange)="listenCustomer($event)"></customer>
    <ion-label><h1 class="ion-margin-start">Buffered Items</h1></ion-label>
    <ion-list *ngFor="let site of sites">
        <ion-list-header>
            <ion-label><h2>{{site.name}}</h2></ion-label>
        </ion-list-header>
        <ion-item *ngFor="let line of detailLinesInHospital | filterDetailLineBySite: [site.id, 'live'] ">
            <ion-label>
                <p>{{line.description}}</p>
                <p>{{line.pdesc}}/{{line.reg}}</p>
                <p>Patient Id:{{line.patientId}} | Ward:{{line.siteDescription}}</p>
            </ion-label>
            <ion-icon slot="end" name="checkmark" *ngIf="line.isChecked" color="success"></ion-icon>
        </ion-item>
    </ion-list>

    <ion-label class="ion-margin-start"><h1>In contract or Cancelled</h1></ion-label>
    <ion-list *ngFor="let site of sites">
        <ion-list-header>
            <ion-label><h2>{{site.name}}</h2></ion-label>
        </ion-list-header>
        <ion-item *ngFor="let line of detailLinesInHospital | filterDetailLineBySite: [site.id, 'collection'] ">
            <ion-label>
                <p>{{line.description}}</p>
                <p>{{line.pdesc}}/{{line.reg}}</p>
                <p>Patient Id:{{line.patientId}} | Ward:{{line.siteDescription}}</p>
            </ion-label>
            <ion-icon slot="end" name="checkmark" *ngIf="line.isChecked" color="success"></ion-icon>
        </ion-item>
    </ion-list>

</ion-content>
